import * as React from 'react';
import BMAFormContext from './BMAForm';

// Simple hook to use the BMAForm context provider
export default function useBMAForm() {
  const form = React.useContext(BMAFormContext);

  return { ...form };
}
